/**
 * Returns true if the user is subscribed to the given question category
 * @param {Object} category - The question category object
 * @return {boolean} Whether the user is subscribed to the category
 */
export function isQuestionCategorySubscribed(category) {
    return category.subscribed;
}
